import React, { useRef, useState, useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import './Recorder.css';
import { UploadPhoto } from '../../s3Func/s3Upload';
import Webcam from 'react-webcam';
import { Buffer } from 'buffer';
import countdownSound from './../../PhotoTime/count_down_beep.m4a';
import loading from './../../loading-gif-png-5.gif';
window.Buffer = Buffer;

export default function Recorder(props) {
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;
  
  const confirmIcon = generateImageUrl('images/Module1Images/check_button_small.png')
  const cancelIcon = generateImageUrl('images/Module1Images/x_button.png')
  const playButton = generateImageUrl('images/Images/Video play.png')
  const pauseButton = generateImageUrl('images/Images/pause.png')

  const [waiting, setWaiting] = useState(false);

  const webcamRef = React.useRef(null);
  const audioRef = React.useRef(null);
  const instructionVideoRef = React.useRef(null);
  const mediaRecorderRef = React.useRef(null);
  const [, forceUpdate] = useState();
  const [capturing, setCapturing] = React.useState(false);
  const [notCapturing, setNotCapturing] = React.useState(false);
  const [recordedChunks, setRecordedChunks] = React.useState([]);
  const [dataUri, setDataUri] = useState('');
  const text = props.outputText;
  const [displayRecorder, setDisplayRecorder] = useState(!props.question);
  const [showStart, setShowStart] = useState(false);
  const [contin, setContin] = useState(false);
  const [pause, setPause] = useState(false);
  const recordAudio = new Audio(props.voice);
  const cdSound = new Audio(countdownSound);
  const timer = useRef();
  const [Exit, setExit] = useState(login.cloudFront + 'images/Images/close.png' + login.cookie);

    const [videoConstraints, setVideoConstraints] = useState({
      width: 391,
      height: 580,
    });

  function isIOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }
  
  /** 
   * On some of the iOS devices, the video gets too big so that Safari fails to process the file and returns 0-byted one without failing (which is undocumented and, obviously, an error).
   * As a workaround, we reduce the quality of a video in the native recording API (which is used by the `videojs-record` and `RecordRTC` internally) so that it won't get to this size.
   * 
   * TODO: remove it when https://bugs.webkit.org/show_bug.cgi?id=85851 is resolved by Apple.
   */
  if (isIOS()) {
    
    const DefaultMediaRecorder = MediaRecorder;
    const kb = 8 * 1024;
    const preferredBitRatePerSecond = 100 * kb;
    MediaRecorder = class extends DefaultMediaRecorder {
      constructor(stream, options) {
        super(stream, {
          ...options, 
          audioBitsPerSecond: preferredBitRatePerSecond,
          videoBitsPerSecond: preferredBitRatePerSecond,
        });
      }
    }
  }

  const handleDataAvailable = React.useCallback(
    ({ data }) => {
      if (data.size > 0) {
        setRecordedChunks((prev) => prev.concat(data));
      }
    },
    [setRecordedChunks]
  );

  const handleStopCaptureClick = React.useCallback(() => {
    mediaRecorderRef.current.stop();
    mediaRecorderRef.current.addEventListener(
      'dataavailable',
      handleDataAvailable
    );
    setCapturing(false);
    setNotCapturing(false);
    setContin(true);
    clearTimeout(timer.current);
  }, [handleDataAvailable, mediaRecorderRef, setCapturing]);

  const handleStartCaptureClick = React.useCallback(() => {
    setCapturing(false);
    setNotCapturing(true);
    mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
      mimeType: isIOS() ? 'video/mp4' : 'video/webm',
    });
    mediaRecorderRef.current.start();
    timer.current = setTimeout(() => handleStopCaptureClick(), 20000);
  }, [webcamRef, setCapturing, mediaRecorderRef, handleStopCaptureClick]);

  function uploadVid() {
    if (recordedChunks.length) {
      const newBlob = new Blob(recordedChunks, {
        type: 'video/mp4',
      });
      const url = URL.createObjectURL(newBlob);
      setRecordedChunks([]);
      return url;
    }
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  useEffect(() => {
    if (displayRecorder) {
      sleep(2000).then(() => {
        setCapturing(true)
      });
    }
  }, []);

  useEffect(() => {
    if (displayRecorder || showStart) return;
    const videoEl = instructionVideoRef.current;
    if (!videoEl) return;
    const tryPlay = () => {
      const maybePromise = videoEl.play();
      if (maybePromise && typeof maybePromise.then === 'function') {
        maybePromise.catch(() => {});
      }
    };
    tryPlay();
    const onUserInteract = () => tryPlay();
    window.addEventListener('touchstart', onUserInteract, { once: true });
    window.addEventListener('click', onUserInteract, { once: true });
    return () => {
      window.removeEventListener('touchstart', onUserInteract);
      window.removeEventListener('click', onUserInteract);
    };
  }, [displayRecorder, props.instruction, showStart]);

  return waiting ? 
  (
    <div
      id='recordpage'
      style={{ backgroundImage: `url(${props.background})` }}
    >
      < img id='loading' src={loading} />
    </div>
  )
  : dataUri ? 
  (
    <div
      id='recordpage'
      style={{ backgroundImage: `url(${props.background})` }}
    >
      <img
        className='back-btn-ftb'
        alt=''
        src={Exit}
        onClick={() => {
          props.close(false);
        }}
      ></img>
      <div id='border1'>
        <video className='displayVideo' playsInline>
          <source src={props.question} type='video/mp4'></source>
        </video>
        <h4 id='cameraText'>Use this video?</h4>
        <video
          id='record-video'
          autoPlay
          src={dataUri}
          onEnded={() => {
            setPause(false);
            document.getElementById('pauseButton').src = playButton;
          }}
          onError={() => {
            setPause(false);
            document.getElementById('pauseButton').src = playButton;
          }}
          playsInline
        />
        <img
          className='cancel'
          alt=''
          style={{
            width: '75px',
            height: '75px',
            cursor: 'pointer',
          }}
          src={cancelIcon}
          onClick={() => {
            setDataUri(null);
            sleep(2000).then(() => {
              setCapturing(true)
            });
            setContin(false);
            setNotCapturing(false);
            forceUpdate();
          }}
        />
        <img
          id='pauseButton'
          alt=''
          style={{
            left: '50%',
            marginLeft: '-37.5px',
            position: 'absolute',
            bottom: '1vh',
            width: '75px',
            height: '75px',
            cursor: 'pointer',
          }}
          src={playButton}
          onClick={() => {
            if (pause) {
              document.getElementById('record-video').pause();
              document.getElementById('pauseButton').src = playButton;
              setPause(!pause);
            } else {
              document.getElementById('record-video').play();
              document.getElementById('pauseButton').src = pauseButton;
              setPause(!pause);
            }
          }}
        />
        <img
          className='confirm'
          alt=''
          style={{
            width: '75px',
            height: '75px',
            cursor: 'pointer',
          }}
          src={confirmIcon}
          onClick={ async () => {
            setWaiting(true);
            const result = await UploadPhoto(dataUri, 'userfiles', props.name, 'video/mp4', login.studentid);
            if (result === 200){
              props.setPlayVideo(dataUri);
              props.setDisplayCelebrateAfterVideo(true);
              props.setDisplayCelebrateRecord(false);
              if (props.end) {
                props.end();
              }
              setWaiting(false);
            }
            else{
              window.alert('Whoops, failed to upload. It looks like the internet connection was lost. Please try again after login.');
              window.location.reload(false);
            }
          }}
        />
      </div>
      <img className='recordAnimal' src={props.animal} alt='' />
    </div>
  ) : (
    <>
      <div
        id='recordpage'
        style={{ backgroundImage: `url(${props.background})` }}
      >
        <img
          className='back-btn-ftb'
          src={Exit}
          alt=''
          onClick={() => {
            props.close(false);
          }}
        ></img>
        {!displayRecorder && (
          <div id='borderVideo' style={{ position: 'relative' }}>
            {showStart && (
              <Button
                onClick={() => {
                  const v = instructionVideoRef.current;
                  if (!v) return;
                  v.muted = false;
                  v.play().catch(() => {});
                  setShowStart(false);
                }}
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  zIndex: 2,
                }}
              >
                Start practice
              </Button>
            )}
            <video
              id="record-video"
              ref={instructionVideoRef}
              autoPlay
              preload='auto'
              onPlaying={() => {
                setShowStart(false);
              }}
              onEnded={() => {setDisplayRecorder(true);
                sleep(2000).then(() => {
                  setCapturing(true)
              })}}
              onError={() => {setDisplayRecorder(true);
                sleep(2000).then(() => {
                  setCapturing(true)
              })}}
              playsInline
            >
              <source src={props.question} type='video/mp4'></source>
            </video>
          </div>
        )}
        {displayRecorder && (
          <audio autoPlay ref={audioRef}>
            <source src={props.voice}></source>
          </audio>
        )}
        {displayRecorder && (
          <div id='border1'>
            <video className='displayVideo' playsInline>
              <source src={props.question} type='video/mp4'></source>
            </video>
            <h4
              id='cameraText'
            >
              {text}
            </h4>
            <Webcam
              id='record-video'
              audio={true}
              muted
              videoConstraints={isIOS() ? {height: 391, width: 580} : videoConstraints}
              ref={webcamRef}
            />
            {notCapturing && (
              <button
                className='stopButton'
                style={{ backgroundColor: 'rgb(255, 105, 105)' }}
                onClick={() => {
                  handleStopCaptureClick();
                }}
              ></button>
            )}
            {capturing && (
              <button
                className='recordButton'
                onClick={() => {
                  cdSound.play();
                  audioRef.current.pause();
                  sleep(500).then(() => {
                    handleStartCaptureClick();
                  });
                }}
              ></button>
            )}
            {contin && (
              <Button
                className='continueButton'
                onClick={() => {
                  setDataUri(uploadVid());
                }}
              >
                Continue
              </Button>
            )}
          </div>
        )}
        <img className='recordAnimal' src={props.animal} alt='' />
      </div>
    </>
  );
}
